export default {
  common: {
    casino: "कैसीनो",
    more: "और देखें",
    searchGames: "गेम खोजें",
    copied: "कॉपी हो गया!",
    inputTooLong: "इनपुट बहुत लंबा है, कृपया दोबारा दर्ज करें।",
    inputNameCn: "केवल चीनी, अंग्रेज़ी अक्षर, संख्याएँ और अंडरस्कोर की अनुमति है",
    inputCapital: "केवल बड़े अक्षर और अंडरस्कोर की अनुमति है",
    inputLowercaseUnderscore: "केवल छोटे अक्षर और अंडरस्कोर की अनुमति है",
    inputLowercase: "केवल छोटे अक्षरों की अनुमति है",
    inputNoSpace: "कृपया केवल रिक्त स्थान दर्ज न करें",
    inputValidPhone: "कृपया एक वैध फ़ोन नंबर दर्ज करें",
    inputNonNumber: "गैर-संख्यात्मक वर्ण शामिल हैं",
    inputNonLetter: "गैर-अक्षर वर्ण शामिल हैं",
    inputLetterOrNumberOnly: "केवल अक्षर या संख्याओं की अनुमति है",
    phoneFormatError: "फ़ोन नंबर का प्रारूप अमान्य है",
    inputLetterStartNumber: "अक्षर से शुरू होना चाहिए और संख्याएँ शामिल हो सकती हैं",
    inputNoChinese: "चीनी वर्णों की अनुमति नहीं है",
    inputChineseOnly: "केवल चीनी वर्णों की अनुमति है",
    emailFormatError: "ईमेल का प्रारूप अमान्य है",
    urlFormatError: "URL का प्रारूप अमान्य है",
    jsonFormatError: "JSON का प्रारूप अमान्य है",
    networkError: "सर्वर तक पहुँचने में विफल, कृपया बाद में पुनः प्रयास करें।",
    siteUnavailable: "यह साइट फ़िलहाल उपलब्ध नहीं है, कृपया व्यवस्थापक से संपर्क करें।",
    tokenExpired: "आपका सत्र समाप्त हो गया है, कृपया दोबारा साइन इन करें।",
    domainNotAuthorized: "डोमेन अधिकृत नहीं है",
    demoEnvOnly: "डेमो वातावरण, केवल पूर्वावलोकन के लिए",
    passwordLength630: "6-30 वर्ण",
    newPasswordSameAsOld: "नया पासवर्ड पुराने पासवर्ड के समान नहीं हो सकता",
    confirmNewPassword: "कृपया अपने नए पासवर्ड की पुष्टि करें",
    passwordsDoNotMatch: "पासवर्ड मेल नहीं खाते",
    withdrawPasswordChanged: "निकासी पासवर्ड सफलतापूर्वक बदल दिया गया",
    withdrawPasswordSet: "निकासी पासवर्ड सफलतापूर्वक सेट किया गया",
    withdrawPasswordSetFailed: "निकासी पासवर्ड सेट करने में विफल",
    phoneDigitsOnly: "फ़ोन नंबर केवल अंकों का होना चाहिए",
    phoneTooShort: "फ़ोन नंबर बहुत छोटा है (न्यूनतम {min} अंक)",
    phoneTooLong: "फ़ोन नंबर बहुत लंबा है (अधिकतम {max} अंक)",
    phoneInvalidPrefix: "फ़ोन नंबर का उपसर्ग अमान्य है",
    rolloverAll: "सभी प्रकार",
    rolloverAllStats: "सभी स्थितियाँ",
    rolloverSuccessful: "सफल",
    rolloverFailed: "विफल",
    rolloverInProgress: "प्रगति में",
    rolloverSuccess: "सफल",
    rolloverPending: "लंबित",
    rolloverCompleted: "पूर्ण",
    rolloverCancelled: "रद्द",
    rolloverExpired: "समाप्त",
    walletCash: "नकद",
    walletBonus: "बोनस",
    sourceDeposit: "जमा",
    sourceCommission: "कमीशन",
    sourceManualAdd: "मैन्युअल जोड़",
    sourceManualSubtract: "मैन्युअल कटौती",
  },
  redeemCode: {
    enterTip: "पुरस्कार प्राप्त करने के लिए अपना रिडीम कोड दर्ज करें",
    placeholder: "कृपया अपना कोड दर्ज करें",
    redeemBtn: "रिडीम करें",
    pleaseEnterCode: "कृपया अपना रिडीम कोड दर्ज करें",
    redeemSuccess: "रिडीम सफल!",
    redeemFailed: "रिडीम विफल, कृपया पुनः प्रयास करें",
  },
}
